import { useContext, useMemo } from 'react';
import UserInfoProvider from 'marketing-platform-lib/providers/UserInfoProvider';
import { DataFetchingClientProvider, DataFetchingClient, getDataFetchingClientContext } from 'data-fetching-client';
import TrackerProvider from 'framework-asset-preview-lib/internal/shared/providers/TrackerProvider';
import AssetPreviewProvider from 'framework-asset-preview-lib/internal/shared/providers/AssetPreviewProvider';
import { SENTRY_KEYS } from 'framework-asset-preview-lib/internal/shared/constants/sentry';
import ErrorBoundary from 'framework-asset-preview-lib/internal/shared/components/ErrorBoundary';
import ConnectedAssetPreviewSidepanel from 'framework-asset-preview-lib/internal/assetPreview/components/ConnectedAssetPreviewSidepanel';
import ConnectedAssetPreviewPopover from 'framework-asset-preview-lib/internal/assetPreview/components/ConnectedAssetPreviewPopover';
import ConnectedAssetPreviewSidebar from 'framework-asset-preview-lib/internal/assetPreview/components/ConnectedAssetPreviewSidebar';
import ConnectedAssetPreviewCard from 'framework-asset-preview-lib/internal/assetPreview/components/ConnectedAssetPreviewCard';
import ConnectedCarouselAssetPreview from 'framework-asset-preview-lib/internal/assetPreview/components/ConnectedCarouselAssetPreview';
import ConnectedAssetPreviewModal from '../internal/assetPreview/components/ConnectedAssetPreviewModal';
import InlineEditProvider from 'framework-asset-preview-lib/internal/shared/providers/InlineEditProvider';
import DataProvider from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
let fallbackClient;
export const getFallbackClient = () => {
  if (!fallbackClient) {
    fallbackClient = new DataFetchingClient();
  }
  return fallbackClient;
};

/**
 * Main entrypoint for teams to render a preview component for object types.
 * Before rendering the preview itself, we need to setup:
 *  - ErrorBoundary: to track all issues coming from this lib in Sentry.
 *  - Tracker: to track all events throughout the code.
 *  - Any other shared code that needs to be at a high-level.
 */
export default function AssetPreview(props) {
  const {
    client: maybeExistingClient
  } = useContext(getDataFetchingClientContext());
  const {
    applicationId,
    crmObject,
    objectId,
    objectType,
    onUpdateCrmObject,
    originObjectType,
    previewType,
    propertyGroups,
    readOnly
  } = props;
  const fingerprint = useMemo(() => previewType === 'sidepanel' ? SENTRY_KEYS.TOP_LEVEL_SIDEPANEL_PREVIEW : SENTRY_KEYS.TOP_LEVEL_POPOVER_PREVIEW, [previewType]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    applicationId: applicationId,
    fingerprint: fingerprint,
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: maybeExistingClient || getFallbackClient(),
      children: /*#__PURE__*/_jsx(AssetPreviewProvider, {
        applicationId: applicationId,
        objectId: objectId,
        objectType: objectType,
        onUpdateCrmObject: onUpdateCrmObject,
        originObjectType: originObjectType,
        previewType: previewType,
        readOnly: readOnly,
        children: /*#__PURE__*/_jsx(DataProvider, {
          crmObject: crmObject,
          propertyGroups: propertyGroups,
          children: /*#__PURE__*/_jsx(TrackerProvider, {
            children: /*#__PURE__*/_jsx(UserInfoProvider, {
              children: /*#__PURE__*/_jsxs(InlineEditProvider, {
                children: [previewType === 'popover' ? /*#__PURE__*/_jsx(ConnectedAssetPreviewPopover, Object.assign({}, props)) : null, previewType === 'sidepanel' ? /*#__PURE__*/_jsx(ConnectedAssetPreviewSidepanel, Object.assign({}, props)) : null, previewType === 'sidebar' ? /*#__PURE__*/_jsx(ConnectedAssetPreviewSidebar, Object.assign({}, props)) : null, previewType === 'card' ? /*#__PURE__*/_jsx(ConnectedAssetPreviewCard, Object.assign({}, props)) : null, previewType === 'carousel' ? /*#__PURE__*/_jsx(ConnectedCarouselAssetPreview, Object.assign({}, props)) : null, previewType === 'modal' ? /*#__PURE__*/_jsx(ConnectedAssetPreviewModal, Object.assign({}, props)) : null]
              })
            })
          })
        })
      })
    })
  });
}